<template>
    <div v-if="address">
        <v-overlay :model-value="loading"
                   contained
                   class="align-center justify-center dulux-box">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <div style="margin-left: 16px;">
            <h5 class="mb-2 pb-2 border-bottom">Corrosivity Zone</h5>
            <div v-if="mapData" class="d-flex bd-highlight border-bottom">
                <div class="p-2 flex-fill bd-highlight d-inline-flex">
                    <div class="d-inline-block">
                        <small class="text-muted">ADDRESS</small><br />
                        <span>{{ address.address_1 }}, {{ address.city }}</span>
                    </div>
                </div>
                <div class="p-2 flex-fill bd-highlight">
                    <div :class="'result-block '+resultClass">
                        {{ resultZone }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .dulux-box {
        margin-top: 2rem;
        margin-bottom: 2rem;
    }

    .corrosive-icon {
        height: 40px;
        margin-top: 5px;
        margin-right: 20px;
    }

    .c1 {
        background-color: #002d62;
    }

    .c2 {
        background-color: #d31245;
    }

    .c3 {
        background-color: #8dc63f;
    }

    .c4 {
        background-color: #ffd200;
    }

    .c5 {
        background-color: #0055a4;
    }

    .result-block {
        color: #fff;
        padding: 10px;
        text-align: center;
        width: 50px;
        margin-right: auto;
        margin-top: 10px;
    }
</style>
<script>
    import { mapActions, mapState, mapGetters } from "vuex";
    function initialState() {
        return {
            loading: false,
            mapData: null,
            categoryZone: null,
            backUp: false
        };
    }
    export default {
        name: "CorrosivityZone",
        data: function () {
            return initialState();
        },
        mounted: function () {
            if (this.address) {
                this.loading = true;
                try
                {
                this.$api.get("/Warranty/GetDuluxCorrosivityZone/?Latitude=" + this.address.latitude + '&Longitude=' + this.address.longitude)
                    .then(res => {
                        this.loading = false;
                        if (res.data && res.data.length > 0) {
                            this.mapData = res.data;
                            // Google maps polygon contains
                            // eslint-disable-next-line no-undef
                            google.maps.Polygon.prototype.Contains = function (point) {
                                var crossings = 0,
                                    path = this.getPath();

                                // for each edge
                                for (var i = 0; i < path.getLength(); i++) {
                                    var a = path.getAt(i),
                                        j = i + 1;
                                    if (j >= path.getLength()) {
                                        j = 0;
                                    }
                                    var b = path.getAt(j);
                                    if (rayCrossesSegment(point, a, b)) {
                                        crossings++;
                                    }
                                }

                                // odd number of crossings?
                                return (crossings % 2 == 1);

                                function rayCrossesSegment(point, a, b) {
                                    var px = point.lng(),
                                        py = point.lat(),
                                        ax = a.lng(),
                                        ay = a.lat(),
                                        bx = b.lng(),
                                        by = b.lat();
                                    if (ay > by) {
                                        ax = b.lng();
                                        ay = b.lat();
                                        bx = a.lng();
                                        by = a.lat();
                                    }
                                    // alter longitude to cater for 180 degree crossings
                                    if (px < 0) {
                                        px += 360;
                                    }
                                    if (ax < 0) {
                                        ax += 360;
                                    }
                                    if (bx < 0) {
                                        bx += 360;
                                    }

                                    if (py == ay || py == by) py += 0.00000001;
                                    if ((py > by || py < ay) || (px > Math.max(ax, bx))) return false;
                                    if (px < Math.min(ax, bx)) return true;

                                    var red = (ax != bx) ? ((by - ay) / (bx - ax)) : Infinity;
                                    var blue = (ax != px) ? ((py - ay) / (px - ax)) : Infinity;
                                    return (blue >= red);

                                }

                            };
                            // Go through each provided polgon and check if it contains our lat & long
                            if (this.mapData) {
                                var lat = this.address.latitude;
                                var long = this.address.longitude;
                                var foundCategory = "";
                                this.mapData.some(function (item) {
                                    if (item.geometry.type == "Polygon") {
                                        // Build polygons
                                        var polygonCoordinates = item.geometry.coordinates[0].map(function (object) {
                                            return { lat: object[1], lng: object[0] };
                                        });
                                        // eslint-disable-next-line no-undef
                                        var point = new google.maps.LatLng(lat, long);
                                        // eslint-disable-next-line no-undef
                                        var polygon = new google.maps.Polygon({ path: polygonCoordinates });
                                        if (polygon.Contains(point)) {
                                            foundCategory = item.properties.category;
                                            return true;
                                        }
                                    }
                                });
                                this.foundCategory = foundCategory;
                                this.backUp = false;
                                this.$emit('update:zone', "C" + this.foundCategory);
                            }
                        }
                    });
                } catch (error) {
                    this.backUp = true;
                }
            }
        },
        props: {
            address: Object,
            zone: String
        },
        methods: {
            reset: function () {
                Object.assign(this.$data, initialState());
            },
        },
        computed: {
            resultClass() {
                if (this.foundCategory) {
                    return "c" + this.foundCategory;
                }
                return "";
            },
            resultZone() {
                if(this.foundCategory) {
                    return "C" + this.foundCategory;
                }
                return "";
            }
        }
    };
</script>